import { apiClient } from './api-client';
import type { MenuRoleSet, MenuRoleSetSaveRequest } from '@/types/menu-role-set';

export const menuRoleSetClient = {
  async getMyMenus(): Promise<string[]> {
    const res = await apiClient.get('me/menus').json<{ result?: string[] }>();
    return res.result ?? [];
  },
  async list(): Promise<MenuRoleSet[]> {
    const res = await apiClient.get('admin/menu-role-sets').json<{ result?: MenuRoleSet[] }>();
    return res.result ?? [];
  },
  async create(req: MenuRoleSetSaveRequest): Promise<MenuRoleSet> {
    const res = await apiClient.post('admin/menu-role-sets', { json: req }).json<{ result: MenuRoleSet }>();
    return res.result;
  },
  async update(setId: number, req: MenuRoleSetSaveRequest): Promise<MenuRoleSet> {
    const res = await apiClient.put(`admin/menu-role-sets/${setId}`, { json: req }).json<{ result: MenuRoleSet }>();
    return res.result;
  },
  async remove(setId: number): Promise<void> {
    await apiClient.delete(`admin/menu-role-sets/${setId}`);
  },
  async assignToUser(userId: number, roleSetId: number): Promise<void> {
    await apiClient.put(`admin/users/${userId}/menu-role-set`, { json: { roleSetId } });
  },
};

